export default __webpack_public_path__ + "static/media/plag.ae58d0c2.svg";